import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { SadieStatDelta } from "@/components/tools/sadie-dashboard/SadieStatDelta";
import { Card } from "@ui/card";

import { sadieDashboard } from "@/lib/sadieDashboard";
import {
  SadieDashboardRange,
  SadieDashboardStat,
  SadieStatFormat,
} from "@/types";

// Opt-out rates are small, so whole percents would hide every change.
const RATE_DECIMALS = 1;

// Workers who opted out in the window, out of everyone Sadie could reach at
// some point in it. Down is the good direction.
export const SadieOptOutRateCard = ({
  optOutRate,
  range,
}: {
  optOutRate: SadieDashboardStat;
  range: SadieDashboardRange;
}) => {
  /* Helpers */
  const counts = sadieDashboard.formatCounts(optOutRate);

  /* Render */
  return (
    <Card className="p-5">
      <Column className="gap-3">
        <Column className="gap-0.5">
          <Text className="font-plex-mono text-[9px] font-medium uppercase tracking-wider text-slate-500">
            Health
          </Text>
          <Text className="text-sm font-semibold text-slate-900">
            Opt-out rate
          </Text>
        </Column>
        <Text className="text-3xl font-semibold text-slate-900">
          {sadieDashboard.formatValue(
            optOutRate,
            SadieStatFormat.RATE,
            RATE_DECIMALS,
          )}
        </Text>
        <SadieStatDelta
          decimals={RATE_DECIMALS}
          format={SadieStatFormat.RATE}
          isUpGood={false}
          range={range}
          stat={optOutRate}
        />
        {counts ? (
          <Text className="text-xs font-normal text-slate-500">
            {counts} reachable workers opted out
          </Text>
        ) : null}
      </Column>
    </Card>
  );
};
